<template>
  <div>
    <el-col v-bind="colSpan">
      <template v-for="(item, index) in colItem">
        <data-show :label="item.label" :key="index">
          <template v-if="item.slotName">
            <slot :name="item.slotName"></slot>
          </template>
          <template v-else-if="item.filters">
            <template v-if="typeof(item.filters) === 'string'">
              <div :class="item.className">
                {{transformFilter(data[item.prop],item.filters)}}
              </div>
            </template>
            <template v-else>
              <div :class="item.className">
                {{item.filters(data[item.prop], item)}}
              </div>
            </template>
          </template>
          <template v-else-if="item.isNull">
            <div :class="item.className">
              {{getValue(item.value, item.prop)}}
            </div>
          </template>
          <template v-else>
            <div :class="item.className">
              {{getValue(item.value, item.prop)}}
            </div>
          </template>
        </data-show>
      </template>
    </el-col>
  </div>
</template>

<script>
import _ from 'lodash';
import dataShow from '../data-show';

export default {
  components: { dataShow },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    dataShow: {
      type: Array,
      default: () => ([]),
    },
    colSpan: {
      type: Object,
      default: () => ({
        span: 8,
        xs: 24,
        sm: 12,
        md: 8,
      }),
    },
  },
  data() {
    return {};
  },
  computed: {
    colItem() {
      if (!this.dataShow || this.dataShow.length === 0) {
        return [];
      }
      // const cellList = (this.dataShow || []).map((col) => {
      //   col.value = col.value || (this.colData ? this.colData[col.prop] : null);
      //   return col;
      // });
      // 过滤不展示的数据
      const cellList = this.dataShow.filter((item) => item.show === undefined || (typeof item.show === 'function' && item.show()));
      return cellList || [];
    },
  },
  methods: {
    getValue(value, prop) {
      let val = '-';
      if (value) {
        val = value;
      }
      if (this.data) {
        val = this.data[prop] || '-';
      }
      return val;
    },
    /**
     * @desc 过滤器使用
     * @param {value} val 原值
     * @param {filterNames} filterNames 过滤器名称
     * @return {newValue} String
     */
    transformFilter(val, filterNames) {
      if (!val && typeof val !== 'number') {
        return '-';
      }
      const filters = _.map(_.split(filterNames, '|'), _.trim);
      const newVal = _.reduce(filters, (vals, funStr) => {
        const funName = funStr.substring(0, funStr.indexOf('(')) || funStr;
        const funParam = _.trim(funStr.substring(funStr.indexOf('(') + 1, funStr.indexOf(')')));
        let paramList = [];
        if (funParam) {
          paramList = funParam.split(',');
        }
        if (!this.$options.filters[funName]) return vals;
        return this.$options.filters[funName].apply(this, [vals, ...paramList]);
      }, val);
      return newVal;
    },
  },
};
</script>
